export const findDatingKickCounterpartId = (userId, chatItem) => {
    if (!chatItem || !userId) return null;
    return Number(userId) === Number(chatItem.to_id) ? Number(chatItem.from_id) : Number(chatItem.to_id);
};

export const buildDatingKickPayload = (userId, targetId) => ({
    chat_type: 1,
    user_id: Number(userId),
    chat_id: `sirup_${Number(targetId)}`,
});
